import React from 'react'

const TestimonialsAllCard = () => {
  return (
      <div className='testimonials-board'>
        <div className='card-testimonials'>
            <div className='background-quotation-marks'>
                "
            </div>
            <div className='header-of-card'>
                <img alt='profile' 
                src={'./image-daniel.jpg'}
                className='biz-udpmincho-regular'
                 style={{
                    width:"40px",
                    borderRadius:"50px",
                    border:"0.5px solid hsl(0, 0%, 100%) ;",
                    }} >
                
                </img>
                <div style={{display:"flex",flexDirection:"column",marginLeft:"10px"}}>
                    <div className='name-profile'>Daniel Clifford</div>
                    <div className='status-profile'>Verified Graduate</div>
                </div>
               
            </div>
              <div className='body-of-card'>
                  <div style={{ display: "flex", flexDirection: "column", marginLeft: "10px", width: "80%" }}>
                      <p className='passage-speak'>
                          Diffeculty give it value ,don't quit get back up
                          believe in yourself embrace the pain and watch how far i can go.
                      </p>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", marginLeft: "10px", width: "80%" }}>
                      <p className='passage-long-show'>
                          " The power of understanding things deeply always leads to better outcomes, as it allows us to see situations from different perspectives and find the best solutions. When we strive to improve everything around us, we not only create a better environment for ourselves but also for those around us. There is no reason to walk away from bad situations without first trying to change them for the better, because challenges often present opportunities for growth and learning. "
                      </p>
                  </div>
            </div>
        </div>

          <div className='card-testimonials-two'>
             
              <div className='header-of-card'>
                  <img alt='profile'
                      src={'./image-jonathan.jpg'}
                      className='biz-udpmincho-regular'
                      style={{
                          width: "40px",
                          borderRadius: "50px",
                          border: "0.5px solid hsl(0, 0%, 100%) ;",
                      }} >

                  </img>
                  <div style={{ display: "flex", flexDirection: "column", marginLeft: "10px" }}>
                      <div className='name-profile'>Jonathan joestar</div>
                      <div className='status-profile'>the first jojo</div>
                  </div>

              </div>
              <div className='body-of-card'>
                  <div style={{ display: "flex", flexDirection: "column", marginLeft: "10px", width: "80%" }}>
                      <p className='passage-speak'>
                          The Team is so supportive and positive i want strong and motivate peoples
                          around me and near me.
                      </p>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", marginLeft: "10px", width: "80%" }}>
                      <p className='passage-long-show'>
                          " The power of understanding things deeply always leads to better outcomes, as it allows us to see situations from different perspectives and find the best solutions. When we strive to improve everything around us, we not only create a better environment for ourselves but also for those around us. There is no reason to walk away from bad situations  "
                      </p>
                  </div>
              </div>
          </div>

          <div className='card-testimonials-three'>

              <div className='header-of-card'>
                  <img alt='profile'
                      src={'./image-jeanette.jpg'}
                      className='biz-udpmincho-regular'
                      style={{
                          width: "40px",
                          borderRadius: "50px",
                          border: "0.5px solid hsl(0, 0%, 100%) ;",
                      }} >

                  </img>
                  <div style={{ display: "flex", flexDirection: "column", marginLeft: "10px" }}>
                      <div className='name-profile-two'>Jeanette Harmon</div>
                      <div className='status-profile-two'>Verified Graduate</div>
                  </div>

              </div>
              <div className='body-of-card'>
                  <div style={{ display: "flex", flexDirection: "column", marginLeft: "10px", width: "80%" }}>
                      <p className='passage-speak-two'>
                          The Team is so supportive and positive i want strong and motivate peoples
                          around me and near me.
                      </p>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", marginLeft: "10px", width: "80%" }}>
                      <p className='passage-long-show-three'>
                          " The power of understanding things deeply always leads to better outcomes, as it allows us to see situations from different perspectives and find the best solutions. When we strive to improve everything around us, we not only create a better environment for ourselves but also for those around us.  "
                      </p>
                  </div>
              </div>
          </div>


          <div className='card-testimonials-four'>

              <div className='header-of-card'>
                  <img alt='profile'
                      src={'./image-patrick.jpg'}
                      className='biz-udpmincho-regular'
                      style={{
                          width: "40px",
                          borderRadius: "50px",
                          border: "0.5px solid hsl(0, 0%, 100%) ;",
                      }} >

                  </img>
                  <div style={{ display: "flex", flexDirection: "column", marginLeft: "10px" }}>
                      <div className='name-profile'>patrick basedman</div>
                      <div className='status-profile'>the sigma male</div>
                  </div>

              </div>
              <div className='body-of-card'>
                  <div style={{ display: "flex", flexDirection: "column", marginLeft: "10px", width: "80%" }}>
                      <p className='passage-speak'>
                          The Team is so supportive and positive i want strong and motivate peoples
                          around me and near me.
                      </p>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", marginLeft: "10px", width: "80%" }}>
                      <p className='passage-long-show'>
                          " The power of understanding things deeply always leads to better outcomes, as it allows us to see situations from different perspectives and find the best solutions. When we strive to improve everything around us, we not only create a better environment for ourselves but also for those around us. There is no reason to walk away from bad situations  "
                      </p>
                  </div>
              </div>
          </div>

          <div className='card-testimonials-five'>

              <div className='header-of-card'>
                  <img alt='profile'
                      src={'./image-kira.jpg'}
                      className='biz-udpmincho-regular'
                      style={{
                          width: "40px",
                          borderRadius: "50px",
                          border: "0.5px solid hsl(0, 0%, 100%) ;",
                      }} >

                  </img>
                  <div style={{ display: "flex", flexDirection: "column", marginLeft: "10px" }}>
                      <div className='name-profile-two'>Kira Whittle</div>
                      <div className='status-profile-two'>Verified Graduate</div>
                  </div>

              </div>
              <div className='body-of-card'>
                  <div style={{ display: "flex", flexDirection: "column", marginLeft: "10px", width: "80%" }}>
                      <p className='passage-speak-two'>
                          Such life changing experiance. highly recommened!
                      </p>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", marginLeft: "10px", width: "80%" }}>
                      <p className='passage-long-show-three'>
                          " The power of understanding things deeply always leads to better outcomes, as it allows us to see situations from different perspectives and find the best solutions. When we strive to improve everything around us, we not only create a better environment for ourselves but also for those around us.  "
                      </p>
                  </div>
              </div>
          </div>
    </div>
  )
}

export default TestimonialsAllCard